import React, { useContext } from 'react'
import Logo from '../../assets/logo.png'
import { baseUrl } from '../../constants'
import { appContext } from '../../Context/appProvider'
import Hamburger from 'hamburger-react'

export default function Header() {
  const {user, setShowSidebar, showSidebar} = useContext(appContext)

  return (
    <div className='flex justify-between w-full px-3 py-2 bg-white shadow-md px-5'>
        <div className='flex items-center gap-2'> 
            <div className='hidden max-md:block'> 
              <Hamburger toggled={showSidebar} toggle={() => setShowSidebar(s => !s)} color="#000000" size={25}  />
            </div>
            <img src={Logo} className='w-[40px] object-contain' />
            <p className='text-md text-[#00000080] font-bold uppercase max-md:text-sm'>Seller Page</p>
            {/* <a href='/' target='_blank' className='text-[14px] bg-main px-5 py-2 rounded-sm text-white'>Visit Public Profile</a> */}
        </div>
        <div className='flex gap-2 items-center'>
            <img className='w-[35px] h-[35px] rounded-full object-cover' alt='profile' src={baseUrl + user?.image} />
            <div className='flex flex-col gap-1 max-md:hidden'>
                <p className='text-black text-[16px] tracking-wider font-bold leading-none'>{`${user?.firstName} ${user?.lastName}`}</p>
                <p className='text-black text-[12px] leading-none'>Instructor</p>
            </div>
        </div>
    </div>
  )
}